import { dataHooks } from '@wix/data-hooks'

export const headlessTemplateDataHooks = dataHooks<{
  stepText: {}
  title: {}
  subtitle: {}
  cardTitle: {}
  back: {}
  skip: {}
}>('headless-template')
